module.exports = ".days-off-requests .approved{float:right;color:#4e7e0e}"


//////////////////
// WEBPACK FOOTER
// ./src/app/my-time/notifications/days-off-requests/days-off-requests.component.scss
// module id = 493
// module chunks = 0